function getDefaultExtension(options) {
    if (options && options.defaultExtension) {
        return "." + options.defaultExtension;
    }
    return "." + DEFAULT_EXTENSION;
}
export const DEFAULT_KEY = "default";
const DEFAULT_EXTENSION = "app";
export function parsePath(pathname) {
    const match = pathname.match(/([^\.]*\.[^\/]+)(.*)/);
    if (match == null) {
        return { base: pathname };
    }
    const suffix = !match[2] || match[2] === "" ? undefined : match[2];
    return { base: match[1], suffix };
}
export function createPath(path) {
    return path.base + (path.suffix || "");
}
export function parseSuffix(suffixAsString, options) {
    const defaultExtension = getDefaultExtension(options);
    let suffixWithoutExtension = suffixAsString;
    if (suffixAsString.endsWith(defaultExtension)) {
        suffixWithoutExtension = suffixAsString.substring(0, suffixAsString.length - defaultExtension.length);
    }
    const suffix = {};
    const parts = suffixWithoutExtension.split("/__");
    if (parts[0].length > 0) {
        suffix.default = parts[0];
    }
    parts.forEach((part, index) => {
        if (index === 0) {
            suffix.default = part;
        }
        else {
            const partMatch = part.match(/([^\/]+)?(.*)/);
            if (partMatch != null && partMatch.length === 3) {
                if (partMatch[1]) {
                    const key = partMatch[1];
                    suffix[key] = partMatch[2];
                }
                else {
                    console.error("no key found");
                }
            }
            else {
                console.error("pathname cannot be parsed");
            }
        }
    });
    return suffix;
}
function keyComparator(key1, key2) {
    if (key1 === key2) {
        return 0;
    }
    if (key1 === DEFAULT_KEY) {
        return -1;
    }
    if (key2 === DEFAULT_KEY) {
        return 1;
    }
    {
        return key1.localeCompare(key2);
    }
}
export function updateSuffix(suffixAsString, key, path, options) {
    const suffix = parseSuffix(suffixAsString);
    if (!path) {
        // tslint:disable-next-line:no-dynamic-delete
        delete suffix[key];
    }
    else {
        if (!path.startsWith("/")) {
            throw new Error("path must start with leading slash");
        }
        suffix[key] = path;
    }
    let newSuffix = "";
    Object.keys(suffix)
        .sort(keyComparator)
        .forEach(suffixKey => {
        const prefix = suffixKey === DEFAULT_KEY ? "" : `/__${suffixKey}`;
        newSuffix += prefix + suffix[suffixKey];
    });
    newSuffix = appendExtensionIfNecessary(newSuffix, getDefaultExtension(options));
    return newSuffix;
}
export function appendExtensionIfNecessary(suffix, defaultExtension) {
    if (suffix.length > 0 &&
        (suffix.endsWith(defaultExtension) || !suffix.match(/\.\w+$/))) {
        return suffix + defaultExtension;
    }
    return suffix;
}
